import { Fragment } from "react";
import { Dialog, Transition } from "@headlessui/react";
import { Trans, useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";
import LanguageSwitcher from "../LanguageSwitcher";
export interface sideBarProps {
  open: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

function classNames(...classes: string[]) {
  return classes.filter(Boolean).join(" ");
}

export default function SideBar({ setOpen, open }: sideBarProps) {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const location = useLocation();
  return (
    <Transition.Root show={open} as={Fragment}>
      <Dialog as="div" className="relative z-50" onClose={setOpen}>
        <Transition.Child
          as={Fragment}
          enter="ease-in-out duration-500"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in-out duration-500"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
        </Transition.Child>

        <div className="fixed inset-0 overflow-hidden">
          <div className="absolute inset-0 overflow-hidden">
            <div className="pointer-events-none fixed inset-0 flex max-w-full">
              <Transition.Child
                as={Fragment}
                enter="transform transition ease-in-out duration-500 sm:duration-700"
                enterFrom="-translate-x-full"
                enterTo="-translate-x-0"
                leave="transform transition ease-in-out duration-500 sm:duration-700"
                leaveFrom="-translate-x-0"
                leaveTo="-translate-x-full"
              >
                <Dialog.Panel className="pointer-events-auto w-screen max-w-[16rem]">
                  <div className="fixed w-[16rem] h-full left-0 top-0 z-20 flex flex-grow flex-col overflow-y-auto border-r border-gray-200 bg-white pt-5 pb-4">
                    <div className="flex flex-shrink-0 items-center px-4">
                      <img className="h-8 w-auto" src="/images/sidebar-logo.png" alt="" />
                    </div>
                    <div className="mt-5 flex flex-grow flex-col">
                      <nav
                        className="mt-20 font-ABeeZee flex-1 space-y-1 bg-white px-2"
                        aria-label="Sidebar"
                      >
                        <div className="flex items-center">
                          <button
                            className={classNames(
                              "bg-[#F8F8F8] text-[#1E408E]",
                              "text-gray-600 hover:bg-gray-50 hover:text-gray-900",
                              "relative group w-full flex justify-center items-center py-2 font-medium"
                            )}
                            onClick={() => navigate("/event-collect")}
                          >
                            <span className="absolute left-0 w-1 h-7 rounded-r-lg bg-[#1E408E] text-transparent">
                              {"1"}
                            </span>

                            <Trans i18nKey="Reporting">Reporting</Trans>
                          </button>
                        </div>

                        <div className="flex items-center">
                          {location.pathname.split("/").includes("event-monitoring") ? (
                            <a
                              className={classNames(
                                "bg-white text-gray-600 hover:bg-gray-50 hover:text-gray-900",
                                "relative group w-full flex justify-center items-center py-2 font-medium"
                              )}
                              href="/20230829_Userguide & Guidelines_Event monitoring.pdf"
                              target="_blank"
                            >
                              <Trans i18nKey="Guidelines">Guidelines</Trans>
                            </a>
                          ) : (
                            <a
                              className={classNames(
                                "bg-white text-gray-600 hover:bg-gray-50 hover:text-gray-900",
                                "relative group w-full flex justify-center items-center py-2 font-medium"
                              )}
                              href="/20230829_Userguide & Guidelines_Event collection.pdf"
                              target="_blank"
                            >
                              <Trans i18nKey="Guidelines">Guidelines</Trans>
                            </a>
                          )}
                        </div>
                      </nav>
                      <div className="absolute w-full bottom-[20px] flex justify-end mt-10 px-[20px]">
                        <LanguageSwitcher />
                      </div>
                    </div>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  );
}
